"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GroupsProps = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));
var _Select = _interopRequireDefault(require("../../../Select"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledOptions = _Select["default"].StyledOptions;
var Filters = {
  GROUP: 'group',
  NEW: 'new'
};
var ConversationFilters = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  function ConversationFilters(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ConversationFilters);
    _this = _callSuper(this, ConversationFilters, [props]);
    _this.state = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, Filters.GROUP, (0, _isEmpty2["default"])(props.groups) ? [] : props.groups[0].value), Filters.NEW, props["new"]);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleChangeNew = _this.handleChangeNew.bind(_this);
    _this.handleRef = _this.handleRef.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(ConversationFilters, _React$PureComponent);
  return (0, _createClass2["default"])(ConversationFilters, [{
    key: "handleChange",
    value: function handleChange(_ref) {
      var detail = _ref.detail,
        target = _ref.target;
      var name = target.getAttribute('name');
      var value = detail.value;
      this.setState((0, _defineProperty2["default"])({}, name, value), this.dispatchChangeEvent);
    }
  }, {
    key: "handleChangeNew",
    value: function handleChangeNew(event) {
      event.stopPropagation();
      var target = event.target;
      var checked = target.checked;
      this.setState((0, _defineProperty2["default"])({}, Filters.NEW, checked), this.dispatchChangeEvent);
    }
  }, {
    key: "handleRef",
    value: function handleRef(el) {
      this.el = el;
    }
  }, {
    key: "dispatchChangeEvent",
    value: function dispatchChangeEvent() {
      var onChange = this.props.onChange;
      var event = new CustomEvent('change', {
        bubbles: true,
        detail: {
          value: this.state
        }
      });
      this.el.dispatchEvent(event);
      onChange(event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        activeGroup = _this$props.activeGroup,
        groups = _this$props.groups;
      var isNew = this.state[Filters.NEW];
      return /*#__PURE__*/_react["default"].createElement(StyledConversationFilters, (0, _extends2["default"])({}, this.props, {
        ref: this.handleRef
      }), /*#__PURE__*/_react["default"].createElement(StyledSecondRow, null, !(0, _isEmpty2["default"])(groups) && /*#__PURE__*/_react["default"].createElement(StyledSelect, {
        name: Filters.GROUP,
        onChange: this.handleChange,
        options: groups,
        value: activeGroup
      }), /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
        checked: isNew,
        name: Filters.NEW,
        onChange: this.handleChangeNew
      }, "\u0422\u043E\u043B\u044C\u043A\u043E \u043D\u043E\u0432\u044B\u0435")));
    }
  }]);
}(_react["default"].PureComponent);
var GroupsProps = exports.GroupsProps = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  title: _propTypes["default"].string.isRequire,
  value: _propTypes["default"].string.isRequire
}).isRequired);
ConversationFilters.propTypes = {
  activeGroup: _propTypes["default"].string,
  className: _propTypes["default"].string,
  groups: GroupsProps,
  "new": _propTypes["default"].bool,
  onChange: _propTypes["default"].func
};
ConversationFilters.defaultProps = {
  activeGroup: '',
  className: '',
  groups: null,
  "new": false,
  onChange: Function.prototype
};
var StyledConversationFilters = _styledComponents["default"].div.withConfig({
  displayName: "ConversationFilters__StyledConversationFilters",
  componentId: "sc-16mrd43-0"
})(["display:flex;flex-direction:column;justify-content:space-between;min-height:36px;width:312px;"]);
var StyledSecondRow = _styledComponents["default"].div.withConfig({
  displayName: "ConversationFilters__StyledSecondRow",
  componentId: "sc-16mrd43-1"
})(["display:flex;justify-content:space-between;"]);
var StyledSelect = (0, _styledComponents["default"])(_Select["default"]).withConfig({
  displayName: "ConversationFilters__StyledSelect",
  componentId: "sc-16mrd43-2"
})(["", "{z-index:3;}"], StyledOptions);
var StyledCheckbox = (0, _styledComponents["default"])(_Checkbox["default"]).withConfig({
  displayName: "ConversationFilters__StyledCheckbox",
  componentId: "sc-16mrd43-3"
})(["line-height:36px;align-items:center;background-color:transparent;color:#17181a;font-size:12px;"]);